<template>
  <div class="box">
    <h3 class="title has-text-grey">{{ slugInscripcion }}</h3>
    <form @submit.prevent="inscribir">
      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Tipo de Participante</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth is-primary">
                <select
                  v-model="tipoParticipanteSel"
                  required="required"
                  @change="validarTipoParticipante"
                >
                  <option disabled value>Seleccione tipo</option>
                  <option
                    v-for="tipoParti in tiposParti"
                    :key="tipoParti.id"
                    :value="tipoParti.nombre"
                  >
                    {{ tipoParti.nombre }}
                  </option>
                </select>
                <span class="icon is-left">
                  <i class="fas fa-users"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Tipo de documento</label>
            <div class="select is-fullwidth is-primary">
              <select v-model="tipoDocSel" required="required">
                <option disabled value>Seleccione tipo</option>
                <option
                  v-for="tipoDoc in tiposDoc"
                  :key="tipoDoc.id"
                  :value="tipoDoc.id"
                >
                  {{ tipoDoc.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="label">Nº documento de identidad</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right is-primary"
                type="number"
                required="required"
                min="1"
                autofocus="true"
                v-model="numeroDoc"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="far fa-id-badge"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'documento' in errores">
              <span v-for="error in errores.documento" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>

          <div class="field">
            <label class="label">Fecha de nacimiento</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right is-primary"
                type="date"
                required="required"
                v-model="fechadenacimiento"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="far fa-calendar-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'fecha_nacimiento' in errores">
              <span v-for="error in errores.fecha_nacimiento" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Primer Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input is-primary"
                type="text"
                v-model="primerApellido"
                :disabled="consultando"
                required="required"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_apellido' in errores">
              <span v-for="error in errores.primer_apellido" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
          <div class="field">
            <label class="label">Segundo Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input is-primary"
                type="text"
                v-model="segundoApellido"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_apellido' in errores">
              <span v-for="error in errores.segundo_apellido" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Primer Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input is-primary"
                type="text"
                v-model="primerNombre"
                :disabled="consultando"
                required="required"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_nombre' in errores">
              <span v-for="error in errores.primer_nombre" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
          <div class="field">
            <label class="label">Segundo Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input is-primary"
                type="text"
                v-model="segundoNombre"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_nombre' in errores">
              <span v-for="error in errores.segundo_nombre" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
        </div>
      </div>

      <label class="label">Celular</label>
      <div class="field has-addons">
        <div class="control has-icons-left">
          <span class="select is-primary">
            <select
              v-model="codigoSeleccionado"
              :disabled="consultando"
              required="required"
            >
              <option
                v-for="codigo in codigos"
                :key="codigo.pais"
                :value="codigo.code"
              >
                {{ codigo.code }} - {{ codigo.pais }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-globe"></i>
          </span>
        </div>
        <div class="control has-icons-left is-expanded">
          <input
            class="input has-text-right is-primary"
            type="number"
            v-model="celular"
            required="required"
            :disabled="consultando"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-phone"></i>
          </span>
          <p class="help is-danger" v-if="'celular' in errores">
            <span v-for="error in errores.celular" :key="error"
              >*{{ error }}</span
            >
          </p>
        </div>
      </div>

      <div class="field">
        <label class="label">E-Mail</label>
        <div class="control has-icons-left">
          <input
            class="input is-primary"
            type="email"
            v-model="newEmail"
            :disabled="consultando"
            required="required"
          />
          <span class="icon is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'email' in errores">
          <span v-for="error in errores.email" :key="error">*{{ error }}</span>
        </p>
      </div>

      <div class="field">
        <label class="label">Género:</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth is-primary">
            <select v-model="generoSeleccionado" required="required">
              <option disabled value>Seleccione su género</option>
              <option
                v-for="genero in generos"
                :key="genero.id"
                :value="genero.id"
              >
                {{ genero.name }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-venus-mars"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'genero' in errores">
          <span v-for="error in errores.genero" :key="error">*{{ error }}</span>
        </p>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Departamento</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth is-primary">
                <select
                  v-model="departamentoSeleccionado"
                  required="required"
                  :disabled="consultando"
                >
                  <option disabled value>Seleccione un departamento</option>
                  <option
                    v-for="departamento in departamentos"
                    :key="departamento.id"
                    :value="departamento.id"
                  >
                    {{ departamento.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label class="label">Municipio</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth is-primary">
                <select
                  v-model="municipioSeleccionado"
                  required="required"
                  @click="setMunicipioSeleccionado"
                >
                  <option
                    v-for="municipio in municipios"
                    :key="municipio.id"
                    :value="municipio.id"
                  >
                    {{ municipio.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'municipio' in errores">
              <span v-for="error in errores.municipio" :key="error"
                >*{{ error }}</span
              >
            </p>
          </div>
        </div>
      </div>
      <!-- validación de tipos de participates -->
      <div v-if="validarTipo == 'asistente'" class="container">
        <campos-adicionales />
        <agenda-comp />
      </div>
      <div v-if="validarTipo == 'reto'" class="container">
        <campos-adicionales />
        <reto-comp />
      </div>
      <div v-if="validarTipo == 'experiencia'" class="container">
        <campos-adicionales />
        <experiencia-comp />
      </div>
      <!-- Fin validación de tipos de participates -->
      <div>
        <input type="checkbox" id="checkbox" v-model="habilitarsubmit" />
        <label for="checkbox">
          Autorizo la
          <a
            href="https://www.computadoresparaeducar.gov.co/es/contactanos/politicas-y-condiciones-de-uso"
            target="_blank"
            >política de tratamiendo de datos personales y condiciones de
            uso.</a
          >
        </label>
      </div>

      <div class="container">
        <div class="control">
          <button
            id="btnInscribir"
            v-if="habilitarsubmit"
            class="button is-block is-info is-fullwidth"
            :class="{ 'is-loading': consultando }"
            :disabled="consultando"
          >
            Inscribir
          </button>
        </div>
      </div>
      <p v-if="error_msg" class="help is-danger">{{ error_msg }}</p>
    </form>
  </div>
</template>

<script>
import CamposAdicionales from "@/components/CamposAdicionales.vue";
import AgendaComp from "@/components/AgendaComp.vue";
import ExperienciaComp from "@/components/ExperienciaComp.vue";
import RetoComp from "@/components/RetoComp.vue";
import MultiSelect from "./Inputs/MultiSelect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import _ from "lodash";
import { mapGetters, mapState } from "vuex";
import {
  preInscribir,
  consultarAgenda,
  tiposDocumento,
  departamentos,
  municipiosDepartamento,
  detalleMunicipio,
  sedesMunicipio,
  generos,
  tiposParti,
  horariosGet,
} from "../api";
export default {
  name: "formulario-inscripcion",
  components: {
    MultiSelect,
    vSelect,
    CamposAdicionales,
    AgendaComp,
    ExperienciaComp,
    RetoComp,
  },
  data: function () {
    return {
      error_msg: "",
      departamentos: [],
      municipios: [],
      generos: [],
      tiposParti: [],
      validarTipo: "",
      tipoParticipanteSel: "",
      tipoDocSel: "",
      generoSeleccionado: "",
      departamentoSeleccionado: null,
      municipioSeleccionado: null,
      sedeSeleccionada: null,
      detalleMunicipio: null,
      primerApellido: "",
      segundoApellido: "",
      primerNombre: "",
      segundoNombre: "",
      codigoSeleccionado: "",
      numeroDoc: null,
      tipoSeleccionado: "",
      nivelSelccionado: "",
      direccionIngresada: "",
      fechadenacimiento: "",
      habilitarsubmit: false,
      fileCarta: null,
      codigos: [
        { pais: "Colombia", code: "+57" },
        { pais: "Venezuela", code: "+58" },
        { pais: "Panamá", code: "+507" },
        { pais: "Brasil", code: "+55" },
        { pais: "Perú", code: "+51" },
        { pais: "Ecuador", code: "+593" },
        { pais: "Bolivia", code: "+591" },
        { pais: "Paraguay", code: "+595" },
        { pais: "Uruguay", code: "+598" },
        { pais: "México", code: "+52" },
        { pais: "Costa Rica", code: "+506" },
        { pais: "Cuba", code: "+53" },
        { pais: "Guatemala", code: "+502" },
        { pais: "Honduras", code: "+504" },
        { pais: "Jamaica", code: "+876" },
        { pais: "Nicaragua", code: "+505" },
        { pais: "Puerto Rico", code: "+1787" },
        { pais: "Rep. Dominicana", code: "+809" },
      ],
      errores: [],
      tiposDoc: [],
      newEmail: "",
      celular: "",
      consultando: false,
      sedes: null,
      numeroHorarios: null,
      cel:false,
      rules: {
        required: (value) => !!value || "Obligatorio",
        //counter: (value) => value.length <= 40 || "Max 40 caracateres",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        celular: (value) => {
          const pattern = /^[2-9]\d{2}-\d{3}-\d{4}$/;
          return pattern.test(value) || "Invalid celular.";
        },
      },
    };
  },
  computed: {
    ...mapState([
      "slugInscripcion",
      "slugId",
      "sedeStore",
      "tipoVinStore",
      "nivelStore",
      "areaStore",
      "experienciaStore",
      "nombreEquipoStore",
      "municipioIdStore",
      "horariosStore",
      "cedula"
    ]),
    tipoId() {
      let tipo_documento;
      tipo_documento = _.find(this.tiposDoc, ["id", this.datos.tipo_documento]);
      return tipo_documento ? tipo_documento.name : "Cargando...";
    },
    // documento: function() {
    //         return this.$store.getters.cedula;
    // },
  },
  methods: {
    validarTipoParticipante() {
      switch (this.tipoParticipanteSel) {
        case "Asistente":
          this.validarTipo = "asistente";
          break;
        case "Participante reto":
          this.validarTipo = "reto";
          break;
        case "Participante experiencia":
          this.validarTipo = "experiencia";
          break;
        case "Conferencista":
          this.validarTipo = "conferencista";
          break;
        case "Tallerista":
          this.validarTipo = "tallerista";
          break;
        default:
          break;
      }
    },

    inscribir() {
      this.checkcel();
      this.numeroHorarios = this.$store.state.horariosStore.length;
      if (this.numeroHorarios < 1 && this.validarTipo == "asistente") {
        alert("seleccione al menos un taller para continuar");
      } else {
        if (this.cel == true) {
          this.errores = {};
          this.consultando = true;
          axios
            .post(preInscribir(), {
              //campos fijos
              tipoParticipante: this.tipoParticipanteSel,
              inscripcion: this.$store.state.slugId,
              tiposDocumento: this.tipoDocSel,
              documento: this.numeroDoc,
              fecha_nacimiento: this.fechadenacimiento,
              primerApellido: this.primerApellido,
              segundoApellido:
                this.segundoApellido == null ? "" : this.segundoApellido,
              primerNombre: this.primerNombre,
              segundoNombre:
                this.segundoNombre == null ? "" : this.segundoNombre,
              celular: this.codigoSeleccionado + this.celular,
              email: this.newEmail,
              genero: this.generoSeleccionado,
              departamento: this.departamentoSeleccionado,
              municipio: this.municipioSeleccionado,
              //campos adicionales
              sede: this.$store.state.sedeStore,
              area: this.$store.state.areaStore,
              vinculacion: this.$store.state.tipoVinStore,
              nivel: this.$store.state.nivelStore,
              //Participante Asistente
              horarios: this.$store.state.horariosStore,
              //Participante experiencia
              experiencia: this.$store.state.experienciaStore,
              // Participante reto
              equipo: this.$store.state.nombreEquipoStore,
            })
            .then((response) => {
              // console.log(response);
              // alert("Docente Inscrito");

              alert("La inscripción se ha realizado correctamente");
              this.salir();
            })
            .catch((error) => {
              console.log("Error");
              // alert("Ocurrio un error");
              console.log(error);
              console.log(error.response);
              if (
                error.response.status == 406 ||
                error.response.status == 400
              ) {
                switch (error.response.data.codigo_respuesta) {
                  case 2:
                    this.error_msg = "No hay cupo para este evento";
                    alert("No hay cupo para este evento");
                    break;
                }
              }
            })
            .then(() => {
              this.consultando = false;
              // alert("Operacion completada");
            });
        }
      }
    },
    setMunicipioSeleccionado() {
      this.$store.commit("setMunicipio", this.municipioSeleccionado);
    },
    fetchTiposParti() {
      //this.consultando = true;
      axios
        .get(tiposParti)
        .then((response) => {
          this.tiposParti = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    },
    fetchDptos() {
      this.consultando = true;
      axios
        .get(departamentos)
        .then((response) => {
          // console.log(response);
          this.departamentos = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchMunicipios(departamentoId) {
      this.consultando = true;
      axios
        .get(municipiosDepartamento(departamentoId))
        .then((response) => {
          // console.log(response);
          this.municipios = response.data.results;
          this.sedeSeleccionada = null;
          // this.sedes = null;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchDetalleMunicipio(id) {
      this.consultando = true;
      axios
        .get(detalleMunicipio(id))
        .then((response) => {
          // console.log(response);
          this.detalleMunicipio = response.data;
          //this.departamentoSeleccionado = this.detalleMunicipio.departamento;
          // this.municipioSeleccionado = id;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchTipoDoc: function () {
      this.consultando = true;
      axios
        .get(tiposDocumento)
        .then((response) => {
          //console.log("tipo de documento "+ response.data + "linea 855");
          this.tiposDoc = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    checkcel() {
      if (!(this.celular.length === 10)) {
        this.cel = false;
        alert("Número de celular inválido. El número ingresado debe contener 10 dígitos");
      } else this.cel = true;
    },
    fetchGeneros() {
      this.consultando = true;
      axios
        .get(generos)
        .then((response) => {
          // console.log(response);
          this.generos = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    salir() {
      this.$store.commit("salir");
      this.$router.replace({ path: "/" });
    },
  },
  mounted() {
    this.fetchTiposParti();
    this.fetchDptos();
    this.fetchGeneros();
    this.fetchTipoDoc();
    this.newEmail = this.email;
    this.areaSeleccionada = this.area;
    this.primerApellido = this.dbPrimerApellido;
    this.segundoApellido = this.dbSegundoApellido;
    this.primerNombre = this.dbPrimerNombre;
    this.segundoNombre = this.dbSegundoNombre;
    this.numeroDoc = this.$store.state.cedula;
    this.validarTipoParticipante();
  },
  watch: {
    departamentoSeleccionado: function (departamentoId) {
      this.fetchMunicipios(departamentoId);
    },
    municipioSeleccionado: function (municipioId) {
      if (
        this.tipoParticipanteSel !== "Conferencista" &&
        this.tipoParticipanteSel !== "Tallerista"
      ) {
        // this.fetchSedes(municipioId);
        this.$store.state.municipioIdStore = municipioId;
      }
    },
    fechadenacimiento: function (fechadenacimiento) {
      if (fechadenacimiento != null) {
        var fechaNace = new Date(fechadenacimiento);
        var fechaActual = new Date();

        var mes = fechaActual.getMonth();
        var dia = fechaActual.getDate();
        var año = fechaActual.getFullYear();

        fechaActual.setDate(dia);
        fechaActual.setMonth(mes);
        fechaActual.setFullYear(año);

        let edad = Math.floor(
          (fechaActual - fechaNace) / (1000 * 60 * 60 * 24) / 365
        );
        //console.log(edad);
        if (edad < 18) {
          this.fechadenacimiento = null;
          return alert("El evento es exclusivo para mayores de edad");
        }
      }
    },
  },
};
</script>

<style></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>